module.exports = __webpack_public_path__ + "img/23.005830ff.webp";